import { BaseNetworkActionValidator } from '../base.network.action.validator';
import { ProtectedEntity } from '@nirvana/shared/dtos/types/protected-entities/common';

export class SyncWithEc2ActionValidator extends BaseNetworkActionValidator {
  protected canRunForMultipleItems = false;
  protected requiresTasksEnabled = false;
  protected canRunForUnmanagedCompanies = false;

  protected _canPerformAction(record: ProtectedEntity): boolean {
    const acceptedTypes = [
      Constants.ProtectedEntities.EPS.TYPE_AWS_GROUP,
      Constants.ProtectedEntities.EPS.TYPE_AWS_ACCOUNT,
    ];
    return acceptedTypes.includes(record.type);
  }
}
